module.exports = __webpack_public_path__ + "img/cabin-front.5fc293ab.jpg";